const ESMA_SECTION_SOURCE_TABLE_KEYS = {
  ASSUMPTIONS2: 'HEADER_SECTION',
  INVESTMENT_STRATEGIES2: 'INVESTMENT_STRATEGIES',
  MARKET_RISK_PROFILE1: 'MARKET_RISK_PROFILE',
  INVESTOR_LIQUIDITY_PROFILE2: 'INVESTOR_LIQUIDITY_PROFILE',
  INVESTOR_ILLIQUID_ASSET_ARRANGEMENT2: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
  INVESTOR_ILLIQUID_ASSET_ARRANGEMENT3: 'INVESTOR_PREFERENTIAL_TREATMENT',
  FINANCING_PROFILE2: 'FINANCING_PROFILE',
  HISTORICAL_PROFILE2: 'HISTORICAL_PROFILE'
};

export function getEsmaSourceTableKey(sectionKey) {
  return ESMA_SECTION_SOURCE_TABLE_KEYS[sectionKey] || sectionKey;
}

export function isEsmaTableDisabledForFund(fund, sourceTableKey) {
  if (!fund?.visibleTableKeys?.length) return false;
  return !fund.visibleTableKeys.includes(getEsmaSourceTableKey(sourceTableKey));
}

export function getVisibleEsmaReportSections({
  tableSections,
  sections,
  condensedSections,
  currentFund,
  funds = [],
  isAIF001,
  isMultiFunds = false
}) {
  const visibleFunds = isMultiFunds ? funds : [currentFund];
  const hasVisibilityKeys = visibleFunds.some(fund => Array.isArray(fund?.visibleTableKeys));

  if (isAIF001 || !hasVisibilityKeys) {
    return {
      tableSections,
      sections,
      condensedSections
    };
  }

  const visibleTableKeys = new Set(
    visibleFunds.flatMap(fund =>
      Array.isArray(fund.visibleTableKeys) ? fund.visibleTableKeys : []
    )
  );
  const filteredTableSections = (tableSections || []).filter(section => {
    const sourceTableKey = getEsmaSourceTableKey(section?.key);
    return !sourceTableKey || visibleTableKeys.has(sourceTableKey);
  });

  const filteredSections = Object.entries(sections || {}).reduce((acc, [key, value]) => {
    if (visibleTableKeys.has(getEsmaSourceTableKey(key))) {
      acc[key] = value;
    }

    return acc;
  }, {});

  const filteredCondensedSections = Object.entries(condensedSections || {}).reduce(
    (acc, [key, value]) => {
      if (visibleTableKeys.has(getEsmaSourceTableKey(key))) {
        acc[key] = value;
      }

      return acc;
    },
    {}
  );

  return {
    tableSections: filteredTableSections,
    sections: filteredSections,
    condensedSections: filteredCondensedSections
  };
}
